import 'whatwg-fetch'

const GOOGLE_APIKEY = 'AIzaSyCl7xtsUctZy9kCI2EDxQXbfSBbHuIRIsM'

function checkStatus (response) {
  if (response.status >= 200 && response.status < 300) {
    return response
  } else {
    var error = new Error(response.statusText)
    error.response = response
    throw error
  }
}
/*
Axios.get('https://maps.googleapis.com/maps/api/geocode/json', {
    params: {
      place_id: placeId,
      key: GOOGLE_APIKEY,
      language: language
    }
  })
*/
export function getCountryCodeFromPlaceID (placeId, language = 'ru') {
  const url = `https://maps.googleapis.com/maps/api/geocode/json?place_id=${placeId}&key=${GOOGLE_APIKEY}&language=${language}`;
  // makeCORSRequest('GET', url)
  return window.fetch(url)
    .then(checkStatus)
    .then(res => res.json())
    .then(answer => {
      if (!answer.status || answer.status !== 'OK') {
        return Promise.reject(Error('Geodecoder failed with status: ' + answer.status));
        // reject(Error('Geodecoder failed with status: ' + answer.status))
      }

      const addr = answer.results[0]
      const addrComponents = addr ? addr.address_components : []
      const addrComponent = addrComponents.find(i => i.types.includes('country'))
      const isoCode = addrComponent ? addrComponent.short_name : null

      return isoCode
    })
    .catch(err => {
      return Promise.reject(err);
    })
}
